import { ReactNode } from 'react';
import { type MessageDescriptor, useIntl } from 'react-intl';

import { isMessage } from '../../lib/utils';

function PageMeta({
    title = null,
    shareImage,
}: {
    title: ReactNode | MessageDescriptor | null;
    shareImage?: { url: string };
}) {
    const intl = useIntl();
    const { url: shareImageUrl = null } = shareImage || {};
    return (
        <>
            {title !== null ? (
                <title>{isMessage(title) ? intl.formatMessage(title) : title}</title>
            ) : null}
            {shareImageUrl !== null ? <meta property="og:image" content={shareImageUrl} /> : null}
        </>
    );
}

export default PageMeta;
